/* hgn-for-you.js — the For You landing (/pages/for-you?l=LANE&fy=TOKEN).
   Loaded deferred by sections/hgn-for-you.liquid, which also carries the
   copy (JSON block, from section settings) and the inline boot that paints
   the lane headline and stamps data-lane / data-token on the root.

   Flow: GET the replen basket for the token → render the offer strip (if
   a code came back) and the picks → prices from /products/HANDLE.js
   (presentment currency) → Add / Add all.

   Add / Add all mirror the sitewide hgn_basket handler in
   assets/hgn-kit-progress.js: park the flow code with HGNPopup.holdCode
   (or the hgn-popup:state fallback) BEFORE the add, POST /cart/add.js,
   then broadcast hgn:cart:change with the /cart.js payload and fire
   hgn:cart:open so the side cart opens and its welcome auto-apply finds
   the parked code. */
(function () {
  'use strict';
  var root = document.querySelector('[data-hgn-for-you]');
  if (!root || root.__hgnFyBooted) return;
  root.__hgnFyBooted = true;

  var API = root.getAttribute('data-api') || 'https://popup.holygrailnail.co';
  var COPY = {};
  try { COPY = JSON.parse(root.querySelector('[data-fy-copy]').textContent) || {}; } catch (e) { COPY = {}; }
  var LANES = COPY.lanes || {};
  var STATES = COPY.states || {};
  function t(key, fb) { return (COPY[key] != null && COPY[key] !== '') ? String(COPY[key]) : fb; }

  /* Lane + token: the boot stamped them; recompute if it didn't run. */
  var qs = location.search || '';
  var lane = root.getAttribute('data-lane');
  if (!lane) {
    var lm = qs.match(/[?&]l=([a-z]+)/);
    lane = lm && LANES[lm[1]] ? lm[1] : 'generic';
  }
  var token = root.getAttribute('data-token');
  if (token == null) {
    var tm = qs.match(/[?&]fy=([^&#]*)/);
    token = tm ? decodeURIComponent(tm[1]).toLowerCase() : '';
  }
  if (!/^[a-z0-9]{12,24}$/.test(token || '')) token = '';

  function q(sel) { return root.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  var gridEl = q('[data-fy-grid]');
  var msgEl = q('[data-fy-msg]');
  var addAllBtns = qa('[data-fy-add-all]');

  var code = null;      // { code, offer, label, expiresAt } — live and unexpired only
  var picks = [];       // [{ item, product, variant, available, price, compare, card, btn }]
  var currency = '';
  var addedAll = false;

  /* ── analytics ─────────────────────────────────────────────────── */
  function track(action, extra) {
    var props = { lane: lane, action: action, has_code: !!code };
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) props[k] = extra[k];
    var tries = 0;
    (function go() {
      try {
        if (window.klaviyo && typeof window.klaviyo.track === 'function') {
          window.klaviyo.track('For You Page', props);
          return;
        }
      } catch (e) { return; }
      /* klaviyo.js loads async — the view event can beat it. */
      if (++tries < 6) setTimeout(go, 1000);
    })();
  }

  /* ── hero + state ──────────────────────────────────────────────── */
  function hero(c) {
    if (!c) return;
    var e = q('[data-fy-eyebrow]'), h = q('[data-fy-title]'), l = q('[data-fy-lede]');
    if (e) e.textContent = c[0] || '';
    if (h) h.textContent = c[1] || '';
    if (l) l.textContent = c[2] || '';
  }
  function setState(s) {
    root.setAttribute('data-state', s);
    if (s === 'expired' || s === 'stock' || s === 'none') hero(STATES[s]);
  }
  function say(text) {
    if (!msgEl) return;
    msgEl.textContent = text || '';
    msgEl.classList.toggle('is-on', !!text);
  }

  /* ── money ─────────────────────────────────────────────────────── */
  /* Same rules as the side cart's formatMoney: Shopify's money format
     only for GBP (theme.moneyFormat is the shop's £ format), Intl for
     every other presentment currency. */
  function formatMoney(cents, cur) {
    var n = (cents || 0) / 100;
    var c = String(cur || 'GBP').toUpperCase();
    if (c === 'GBP' && window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      try { return window.Shopify.formatMoney(cents, window.theme.moneyFormat); } catch (e) {}
    }
    try {
      return new Intl.NumberFormat(c === 'GBP' ? 'en-GB' : undefined, { style: 'currency', currency: c }).format(n);
    } catch (e) {
      return '£' + n.toFixed(2);
    }
  }
  /* Presentment currency: a non-empty cart's currency is authoritative
     (an EMPTY cart reports the shop's base GBP whatever the market), then
     what the side cart learned, then the market Liquid rendered, then
     Shopify.currency.active. */
  function resolveCurrency(cart) {
    if (cart && cart.item_count > 0 && cart.currency) return String(cart.currency).toUpperCase();
    var raw = window.HGN && window.HGN.cartCurrencyRaw;
    if (raw) return String(raw).toUpperCase();
    var liq = root.getAttribute('data-currency');
    if (liq) return String(liq).toUpperCase();
    var sc = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return String(sc || 'GBP').toUpperCase();
  }

  /* ── offer strip ───────────────────────────────────────────────── */
  function parseDate(s) {
    if (!s) return null;
    var str = String(s);
    /* D1 datetime() shape ("2026-10-09 22:59:59") → ISO UTC; Safari
       won't parse the space form. */
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(str)) str = str.replace(' ', 'T') + (/[zZ]|[+-]\d{2}:?\d{2}$/.test(str) ? '' : 'Z');
    var d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
  }
  function londonDay(d) {
    try { return d.toLocaleDateString('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }); }
    catch (e) { return d.toDateString(); }
  }
  function endsText(d) {
    var prefix = t('offerEnds', 'Ends');
    var now = new Date();
    if (londonDay(d) === londonDay(now)) return prefix + ' today';
    if (londonDay(d) === londonDay(new Date(now.getTime() + 86400000))) return prefix + ' tomorrow';
    var label;
    try { label = d.toLocaleDateString('en-GB', { timeZone: 'Europe/London', weekday: 'long', day: 'numeric', month: 'long' }); }
    catch (e) { label = d.toDateString(); }
    return prefix + ' ' + label;
  }
  function offerLabel(c) {
    var l = String(c.label || '');
    if (!l) {
      var which = lane === 'lastchance' ? 'first' : 'next';
      var pct = (String(c.offer || '').match(/^percent(\d+)$/) || [])[1];
      if (pct) l = pct + '% off your ' + which + ' order';
      else if (c.offer === 'freeship') l = 'free shipping on your ' + which + ' order';
    }
    if (!l) return t('offerFallback', 'A little something off your order');
    return l.charAt(0).toUpperCase() + l.slice(1);
  }
  function renderOffer() {
    if (!code) { root.classList.remove('has-code'); return; }
    var lbl = q('[data-fy-offer-label]'), cd = q('[data-fy-offer-code]'), en = q('[data-fy-offer-ends]');
    if (lbl) lbl.textContent = offerLabel(code);
    if (cd) cd.textContent = String(code.code).toUpperCase();
    var d = parseDate(code.expiresAt);
    if (en) en.textContent = d ? endsText(d) : '';
    root.classList.add('has-code');
  }

  /* ── code parking (verbatim logic from the hgn_basket handler) ─── */
  function parkCode() {
    try {
      var fc = code;
      if (fc && fc.code) {
        if (window.HGNPopup && typeof window.HGNPopup.holdCode === 'function') {
          window.HGNPopup.holdCode(fc);
        } else if (String(fc.code).toUpperCase().indexOf('POPUP-') === 0 && fc.expiresAt) {
          var k = 'hgn-popup:state', cur = {};
          try { cur = JSON.parse(localStorage.getItem(k) || '{}') || {}; } catch (e) { cur = {}; }
          cur.code = String(fc.code).toUpperCase(); cur.expiresAt = fc.expiresAt;
          cur.offerLabel = fc.label || ''; cur.subscribed = true; cur.timestamp = Date.now();
          localStorage.setItem(k, JSON.stringify(cur));
        }
      }
    } catch (e) {}
  }

  /* ── cart ──────────────────────────────────────────────────────── */
  function openCart() {
    /* Broadcast a real cart payload (some hgn:cart:change listeners read
       e.detail.cart), then open — same order as the hgn_basket handler. */
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        try { if (cart) document.dispatchEvent(new CustomEvent('hgn:cart:change', { detail: { cart: cart } })); } catch (e) {}
      })
      .catch(function () {})
      .then(function () {
        try { document.dispatchEvent(new CustomEvent('hgn:cart:open')); } catch (e) {}
      });
  }
  function postAdd(lines) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lines })
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      return r.json();
    });
  }
  /* One bad line fails a multi-line /cart/add.js outright (422) — retry
     line by line so the rest still land. Resolves to the count added. */
  function addLines(lines) {
    parkCode();
    return postAdd(lines).then(function () { return lines.length; }, function (err) {
      if (lines.length < 2) throw err;
      var n = 0;
      return lines.reduce(function (p, line) {
        return p.then(function () {
          return postAdd([line]).then(function () { n++; }, function () {});
        });
      }, Promise.resolve()).then(function () {
        if (!n) throw err;
        return n;
      });
    });
  }

  function lineOf(p) { return { id: p.variantId, quantity: p.item.qty || 1 }; }
  function addable() { return picks.filter(function (p) { return p.available; }); }

  function syncAddAll() {
    var live = addable();
    var label = addedAll ? t('addAllDone', 'In your bag. View bag') : t('addAll', 'Add all to bag');
    if (!addedAll && live.length && currency) {
      var priced = live.every(function (p) { return p.price != null; });
      if (priced) {
        var sum = live.reduce(function (a, p) { return a + p.price * (p.item.qty || 1); }, 0);
        label += ' · ' + formatMoney(sum, currency);
      }
    }
    addAllBtns.forEach(function (b) {
      b.textContent = label;
      b.disabled = !live.length && !addedAll;
    });
  }

  function onAddAll(e) {
    var btn = e.currentTarget;
    if (btn.getAttribute('aria-busy') === 'true') return;
    if (addedAll) { openCart(); return; }
    var live = addable();
    if (!live.length) return;
    say('');
    addAllBtns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; b.textContent = t('adding', 'Adding') + '…'; });
    track('add_all', { items: live.length });
    addLines(live.map(lineOf)).then(function () {
      addedAll = true;
      return openCart();
    }).catch(function () {
      say(t('addError', "That didn't go through. Try again in a moment."));
    }).then(function () {
      addAllBtns.forEach(function (b) { b.removeAttribute('aria-busy'); });
      syncAddAll();
    });
  }
  addAllBtns.forEach(function (b) { b.addEventListener('click', onAddAll); });

  function onAddOne(p) {
    var btn = p.btn;
    if (!p.available || btn.getAttribute('aria-busy') === 'true') return;
    say('');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = t('adding', 'Adding') + '…';
    track('add_one', { variant_id: p.variantId, kind: p.item.kind || 'design' });
    addLines([lineOf(p)]).then(function () {
      btn.textContent = t('added', 'Added') + ' ✓';
      btn.classList.add('is-added');
      return openCart();
    }).catch(function () {
      btn.textContent = t('add', 'Add');
      say(t('addError', "That didn't go through. Try again in a moment."));
    }).then(function () {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      setTimeout(function () {
        btn.classList.remove('is-added');
        if (p.available) btn.textContent = t('add', 'Add');
      }, 2500);
    });
  }

  /* ── picks ─────────────────────────────────────────────────────── */
  function sized(url, w) {
    if (!url) return '';
    var u = String(url);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(u) && !/[?&]width=/.test(u)) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    return u;
  }
  /* "Tortoiseshell Noir - Holy Classics (Non-UV Nail Wraps)" →
     name "Tortoiseshell Noir", sub "Holy Classics (Non-UV Nail Wraps)".
     Essentials drop the brand half ("Magic Gloss Top Coat - Holy Grail
     Nail") and carry the Essential tag instead of a range line. */
  function splitTitle(title, consumable) {
    var s = String(title || '').trim();
    if (consumable) {
      s = s.replace(/^Holy Grail Nail\s*[-–—]\s*/i, '').replace(/\s*[-–—]\s*Holy Grail Nail$/i, '');
      return { name: s, sub: '' };
    }
    var i = s.indexOf(' - ');
    if (i < 1) return { name: s, sub: '' };
    /* The format suffix repeats what the range name already says:
       "Holy Classics (Non-UV Nail Wraps)" → "Holy Classics". Design
       qualifiers such as "(Part Transparent)" stay. */
    var sub = s.slice(i + 3).replace(/\s*\((non-uv |semi-cured gel )?nail wraps\)$/i, '');
    return { name: s.slice(0, i), sub: sub };
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function buildCard(p) {
    var it = p.item;
    var consumable = it.kind === 'consumable';
    var href = '/products/' + encodeURIComponent(it.handle || '');
    var parts = splitTitle(it.title, consumable);

    var card = el('article', 'hgn-fy__card');
    var media = el('a', 'hgn-fy__card-media');
    media.href = href;
    media.setAttribute('tabindex', '-1');
    media.setAttribute('aria-hidden', 'true');
    var img = el('img');
    img.alt = parts.name;
    img.loading = 'lazy';
    img.width = 600; img.height = 600;
    var src = sized(it.image, 600);
    if (src) img.src = src;
    p.img = img;
    media.appendChild(img);
    if ((it.qty || 1) > 1) media.appendChild(el('span', 'hgn-fy__card-qty', '× ' + it.qty));
    card.appendChild(media);

    var body = el('div', 'hgn-fy__card-body');
    if (consumable) body.appendChild(el('p', 'hgn-fy__card-kind', t('essential', 'Essential')));
    var a = el('a', 'hgn-fy__card-title', parts.name);
    a.href = href;
    body.appendChild(a);
    if (parts.sub) body.appendChild(el('p', 'hgn-fy__card-sub', parts.sub));
    var price = el('p', 'hgn-fy__card-price is-pending', ' ');
    p.priceEl = price;
    body.appendChild(price);
    body.appendChild(el('span', 'hgn-fy__card-gap'));
    var btn = el('button', 'hgn-btn-ghost hgn-fy__card-add', t('add', 'Add'));
    btn.type = 'button';
    btn.addEventListener('click', function () { onAddOne(p); });
    p.btn = btn;
    body.appendChild(btn);
    card.appendChild(body);
    p.card = card;
    return card;
  }

  function paintPrice(p) {
    var pe = p.priceEl;
    if (!pe) return;
    pe.classList.remove('is-pending');
    if (p.price == null) { pe.parentNode && pe.parentNode.removeChild(pe); p.priceEl = null; return; }
    pe.textContent = formatMoney(p.price, currency);
    if (p.compare && p.compare > p.price) {
      var s = el('s', null, formatMoney(p.compare, currency));
      pe.appendChild(s);
    }
  }
  function paintSoldOut(p) {
    p.card.classList.add('is-soldout');
    p.btn.disabled = true;
    p.btn.textContent = t('soldOut', 'Sold out');
  }

  function loadProduct(p) {
    var h = p.item.handle;
    if (!h) return Promise.resolve();
    return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (prod) {
        if (!prod) return;
        var v = (prod.variants || []).filter(function (x) { return String(x.id) === String(p.variantId); })[0];
        if (v) {
          p.price = typeof v.price === 'number' ? v.price : null;
          p.compare = typeof v.compare_at_price === 'number' ? v.compare_at_price : null;
          if (v.available === false) p.available = false;
        } else if (typeof prod.price === 'number') {
          p.price = prod.price;
        }
        if (!p.item.image && prod.featured_image && p.img) p.img.src = sized(prod.featured_image, 600);
      })
      .catch(function () {});
  }

  function renderPicks(items) {
    var sorted = items.filter(function (it) { return it && it.variant_id; });
    sorted = sorted.filter(function (it) { return it.kind !== 'consumable'; })
      .concat(sorted.filter(function (it) { return it.kind === 'consumable'; }));
    picks = sorted.map(function (it) {
      return { item: it, variantId: it.variant_id, available: true, price: null, compare: null };
    });
    gridEl.innerHTML = '';
    picks.forEach(function (p) { gridEl.appendChild(buildCard(p)); });
    root.classList.toggle('has-many', picks.length > 4);
    syncAddAll();
  }

  /* ── boot ──────────────────────────────────────────────────────── */
  function fetchTimeout(url, opts, ms) {
    var ctl = (typeof AbortController === 'function') ? new AbortController() : null;
    if (ctl) opts.signal = ctl.signal;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, ms) : null;
    return fetch(url, opts).then(function (r) { if (timer) clearTimeout(timer); return r; },
      function (e) { if (timer) clearTimeout(timer); throw e; });
  }

  function finish(state) {
    setState(state);
    track('view', { state: state });
  }

  if (!token) { finish('none'); return; }

  var basketP = fetchTimeout(API + '/api/replen/basket?token=' + encodeURIComponent(token), { credentials: 'omit' }, 10000)
    .then(function (r) {
      return r.json().then(function (d) { return { status: r.status, d: d }; }, function () { return { status: r.status, d: null }; });
    });
  var cartP = fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .catch(function () { return null; });

  basketP.then(function (res) {
    var d = res && res.d;
    if (!d || !d.ok || !Array.isArray(d.items) || !d.items.length) {
      var reason = d && d.reason;
      finish(reason === 'expired' ? 'expired' : reason === 'stock' ? 'stock' : 'none');
      return;
    }
    var c = d.code;
    if (c && c.code) {
      var exp = parseDate(c.expiresAt);
      if (!exp || exp.getTime() > Date.now()) code = c;
    }
    renderOffer();
    renderPicks(d.items);
    if (!picks.length) { finish('stock'); return; }
    setState('ok');

    return cartP.then(function (cart) {
      currency = resolveCurrency(cart);
      return Promise.all(picks.map(loadProduct));
    }).then(function () {
      picks.forEach(function (p) {
        paintPrice(p);
        if (!p.available) paintSoldOut(p);
      });
      syncAddAll();
      /* Every pick unavailable in this market → same as the worker's
         stock answer. */
      if (!addable().length) { code = null; renderOffer(); finish('stock'); return; }
      track('view', { state: 'ok', items: picks.length });
    }).catch(function () {
      /* Prices are garnish: the picks stay usable without them. */
      picks.forEach(function (p) { if (p.priceEl && p.price == null) paintPrice(p); });
      track('view', { state: 'ok', items: picks.length });
    });
  }).catch(function () {
    finish('none');
  });
})();
